<template>
    <div>
        <CCTableAddItems
            :items.sync="componentItems"
            :fields="[
                { key: 'field', label: 'field' },
                { key: 'condition', label: 'condition' },
                {
                    key: 'value',
                    label: 'value',
                },
            ]"
        >
            <template #field="{ item }">
                <SelectAsync
                    :options="fields"
                    :value.sync="item.field"
                    :placeholder="$t('Select a field')"
                    optionsValue="code"
                    optionsLabel="name"
                >
                </SelectAsync>
            </template>
            <template #condition="{ item }">
                <SelectAsync
                    :options="conditions"
                    :value.sync="item.condition"
                    :placeholder="$t('Select a condition')"
                    optionsValue="value"
                    optionsLabel="label"
                >
                </SelectAsync>
            </template>
            <template #value="{ index, item }">
                <CInput
                    :value.sync="item.value"
                    :placeholder="$t('Enter the value')"
                    :invalidFeedback="$t('Value is required')"
                    class="mb-0"
                    size="sm"
                />
            </template>
        </CCTableAddItems>
    </div>
</template>

<script>
/**Components */
import SelectAsync from "£lement/SelectAsync";
import CCTableAddItems from "~/components/CCTableAddItems";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";

export default {
    name: "CCTableAcceptanceFilters",
    mixins: [traslateMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    components: {
        SelectAsync,
        CCTableAddItems,
    },
    data() {
        return {
            componentItems: [],
            componentFields: [],
            componentLoading: false,
        };
    },
    props: {
        fields: {
            type: Array,
            default: [],
        },
        conditions: Array,
        filters: {
            type: String | null,
            required: true,
            validator(value) {
                try {
                    JSON.parse(value);
                    return true;
                } catch (e) {
                    return false;
                }
            },
        },
    },
    watch: {
        filters(newValue) {
            this.componentItems = JSON.parse(newValue) || [];
        },
        componentItems: {
            handler(newValue) {
                this.$emit("update:filters", JSON.stringify(newValue));
            },
            deep: true,
        },
    },
    mounted() {
        this.componentItems = JSON.parse(this.filters) || [];
    },
};
</script>

<style></style>
